import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import ModalStateDialogComponent from "../../../cubeComponent/html/modal/ModalWithState";

const ErrorModal = ({ isVisible, onClose }) => {
  const { t } = useTranslation();
  return (
    <ModalStateDialogComponent
      isVisible={isVisible}
      onCancel={onClose}
      headerTitle={
        <div className="flex justify-between w-full items-center ps-4">
          <h2 className="text-xl font-bold text-[#101828]">{t("Some files couldn't be uploaded")}</h2>
        </div>
      }
      modelContent={
        <div className="flex flex-col p-4 gap-4 rounded-lg min-w-[400px] max-w-[600px] w-full">
          <p className="text-[#344054] text-base -mt-2">
            {t("Some files couldn't be uploaded. This may be due to one of the following reasons:")}
          </p>
          <div className="bg-[rgba(255,207,85,0.5)] border border-[#FDE68A] rounded-xl p-5 w-full">
            <ol className="list-decimal list-inside space-y-3 text-sm text-[#1D2939] leading-relaxed">
              <li className="break-words">
                {t(
                  "You don't have permission to access the file in your local system, even though you may be able to see its name.",
                )}
              </li>
              <li className="break-words">
                {t(
                  "The file is a cloud placeholder (e.g., from Google Drive or similar service) and hasn't been fully downloaded to your system.",
                )}
              </li>
              <li className="break-words">{t("There may be a network or connection issue on your end.")}</li>
            </ol>
          </div>
        </div>
      }
    />
  );
};

ErrorModal.propTypes = {
  isVisible: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default ErrorModal;
